import React, { useState } from 'react';
import { TiDelete, TiPlus } from "react-icons/ti";

const FlowTriggerStack = ({ stack, index, updateStack, deleteStack }) => {
    const [isEditing, setIsEditing] = useState(false);
    const [localStack, setLocalStack] = useState(stack);

    const handleChange = (field, value) => {
        setLocalStack(prev => ({ ...prev, [field]: value }));
    };

    const handleSave = () => {
        updateStack(index, localStack);
        setIsEditing(false);
    };

    const handleCancel = () => {
        setLocalStack(stack);
        setIsEditing(false);
    };

    return (
        <div className="card h-100">
            <div className="card-header text-center" style={{ backgroundColor: '#f8f9fa', cursor: "pointer" }} onClick={() => setIsEditing(!isEditing)}>
                <h5 className="mb-0">Flow Trigger Stack {index + 1}</h5>
            </div>
            <div className="card-body" style={{ padding: '1rem' }}>
                <TiDelete className="text-danger" style={{ fontSize: "1.3em", cursor: "pointer", position: "absolute", top: "8px", right: "8px" }} onClick={() => deleteStack(index)} />
                
                {isEditing ? (
                    <div>
                        <div className="mb-3">
                            <label className="fw-bold text-uppercase">SINGLE TASK/ACTIVITY:</label>
                            <textarea
                                className="form-control"
                                value={localStack.singleTask || ''}
                                onChange={(e) => handleChange('singleTask', e.target.value)}
                                rows={2}
                            />
                        </div>

                        <div className="mb-3">
                            <label className="fw-bold text-uppercase">INTRINSIC MOTIVATOR:</label>
                            <select
                                className="form-select mb-2"
                                value={localStack.intrinsicMotivator || ''}
                                onChange={(e) => handleChange('intrinsicMotivator', e.target.value)}
                            >
                                <option value="">-- Select --</option>
                                <option value="autonomy">Autonomy</option>
                                <option value="curiosityPassionPurpose">Curiosity/Passion/Purpose</option>
                            </select>
                            {localStack.intrinsicMotivator === 'curiosityPassionPurpose' && (
                                <div className="mb-2">
                                    <label className="fw-bold">One liner statement "why this activity matters":</label>
                                    <textarea
                                        className="form-control"
                                        value={localStack.whyMatters || ''}
                                        onChange={(e) => handleChange('whyMatters', e.target.value)}
                                        rows={2}
                                    />
                                </div>
                            )}
                            {localStack.intrinsicMotivator === 'autonomy' && (
                                <div>
                                    <label className="fw-bold">One liner statement "why this activity matters":</label>
                                    <textarea
                                        className="form-control"
                                        value={localStack.autonomyExplanation || ''}
                                        onChange={(e) => handleChange('autonomyExplanation', e.target.value)}
                                        rows={2}
                                    />
                                </div>
                            )}
                        </div>

                        <div className="mb-3">
                            <label className="fw-bold text-uppercase">COMPLETE CONCENTRATION:</label>
                            <textarea
                                className="form-control"
                                value={localStack.completeConcentration || ''}
                                onChange={(e) => handleChange('completeConcentration', e.target.value)}
                                rows={2}
                            />
                        </div>

                        <div className="mb-3">
                            <label className="fw-bold text-uppercase">CLEAR GOAL:</label>
                            <textarea
                                className="form-control"
                                value={localStack.clearGoal || ''}
                                onChange={(e) => handleChange('clearGoal', e.target.value)}
                                rows={2}
                            />
                        </div>

                        <div className="mb-3">
                            <label className="fw-bold text-uppercase">CHALLENGE-SKILL BALANCE:</label>
                            <div className="mb-2">
                                <textarea
                                    className="form-control"
                                    placeholder="Challenge"
                                    value={localStack.challenge || ''}
                                    onChange={(e) => handleChange('challenge', e.target.value)}
                                    rows={2}
                                    style={{ color: localStack.challenge ? 'inherit' : '#6c757d' }}
                                />
                            </div>
                            <div>
                                <textarea
                                    className="form-control"
                                    placeholder="Skill"
                                    value={localStack.skill || ''}
                                    onChange={(e) => handleChange('skill', e.target.value)}
                                    rows={2}
                                    style={{ color: localStack.skill ? 'inherit' : '#6c757d' }}
                                />
                            </div>
                        </div>

                        <div className="mb-3">
                            <label className="fw-bold text-uppercase">IMMEDIATE FEEDBACK:</label>
                            <textarea
                                className="form-control"
                                value={localStack.immediateFeedback || ''}
                                onChange={(e) => handleChange('immediateFeedback', e.target.value)}
                                rows={2}
                            />
                        </div>

                        <div className="mb-3">
                            <label className="fw-bold text-uppercase">CATALYST(S):</label>
                            <select
                                className="form-select mb-2"
                                value={localStack.catalystMain || ''}
                                onChange={(e) => handleChange('catalystMain', e.target.value)}
                            >
                                <option value="">-- Main Catalyst --</option>
                                <option value="deepEmbodiment">Deep Embodiment</option>
                                <option value="richEnvironment">Rich Environment</option>
                                <option value="highConsequence">High Consequence</option>
                                <option value="creativity">Creativity</option>
                                <option value="other">Other</option>
                            </select>
                            {localStack.catalystMain && (
                                <textarea
                                    className="form-control mb-2"
                                    placeholder="Main catalyst explanation"
                                    value={localStack.catalystMainExplanation || ''}
                                    onChange={(e) => handleChange('catalystMainExplanation', e.target.value)}
                                    rows={2}
                                    style={{ color: localStack.catalystMainExplanation ? 'inherit' : '#6c757d' }}
                                />
                            )}
                            <select
                                className="form-select mb-2"
                                value={localStack.catalystOptional1 || ''}
                                onChange={(e) => handleChange('catalystOptional1', e.target.value)}
                            >
                                <option value="">-- Optional Catalyst 1 --</option>
                                <option value="deepEmbodiment">Deep Embodiment</option>
                                <option value="richEnvironment">Rich Environment</option>
                                <option value="highConsequence">High Consequence</option>
                                <option value="creativity">Creativity</option>
                                <option value="other">Other</option>
                            </select>
                            {localStack.catalystOptional1 && (
                                <textarea
                                    className="form-control mb-2"
                                    placeholder="Optional catalyst 1 explanation"
                                    value={localStack.catalystOptional1Explanation || ''}
                                    onChange={(e) => handleChange('catalystOptional1Explanation', e.target.value)}
                                    rows={2}
                                    style={{ color: localStack.catalystOptional1Explanation ? 'inherit' : '#6c757d' }}
                                />
                            )}
                            <select
                                className="form-select mb-2"
                                value={localStack.catalystOptional2 || ''}
                                onChange={(e) => handleChange('catalystOptional2', e.target.value)}
                            >
                                <option value="">-- Optional Catalyst 2 --</option>
                                <option value="deepEmbodiment">Deep Embodiment</option>
                                <option value="richEnvironment">Rich Environment</option>
                                <option value="highConsequence">High Consequence</option>
                                <option value="creativity">Creativity</option>
                                <option value="other">Other</option>
                            </select>
                            {localStack.catalystOptional2 && (
                                <textarea
                                    className="form-control mb-2"
                                    placeholder="Optional catalyst 2 explanation"
                                    value={localStack.catalystOptional2Explanation || ''}
                                    onChange={(e) => handleChange('catalystOptional2Explanation', e.target.value)}
                                    rows={2}
                                    style={{ color: localStack.catalystOptional2Explanation ? 'inherit' : '#6c757d' }}
                                />
                            )}
                            <label className="fw-bold">DATA ENTRY LINE:</label>
                            <textarea
                                className="form-control"
                                value={localStack.catalystDataEntry || ''}
                                onChange={(e) => handleChange('catalystDataEntry', e.target.value)}
                                rows={2}
                            />
                        </div>

                        <div className="mb-3">
                            <label className="fw-bold text-uppercase">FINAL STACK STATEMENT</label>
                            <div className="mb-2">
                                <label className="fw-bold">When will you test this Flow Trigger Stack?</label>
                                <textarea
                                    className="form-control"
                                    value={localStack.whenTest || ''}
                                    onChange={(e) => handleChange('whenTest', e.target.value)}
                                    rows={2}
                                />
                            </div>
                            <div className="mb-2">
                                <label className="fw-bold">What worked?</label>
                                <textarea
                                    className="form-control"
                                    value={localStack.whatWorked || ''}
                                    onChange={(e) => handleChange('whatWorked', e.target.value)}
                                    rows={2}
                                />
                            </div>
                            <div className="mb-2">
                                <label className="fw-bold">What didn't?</label>
                                <textarea
                                    className="form-control"
                                    value={localStack.whatDidnt || ''}
                                    onChange={(e) => handleChange('whatDidnt', e.target.value)}
                                    rows={2}
                                />
                            </div>
                            <div>
                                <label className="fw-bold">What needs adjustment?</label>
                                <textarea
                                    className="form-control"
                                    value={localStack.needsAdjustment || ''}
                                    onChange={(e) => handleChange('needsAdjustment', e.target.value)}
                                    rows={2}
                                />
                            </div>
                        </div>

                        <div className="d-flex gap-2">
                            <button className="btn btn-primary" onClick={handleSave}>Save</button>
                            <button className="btn btn-secondary" onClick={handleCancel}>Cancel</button>
                        </div>
                    </div>
                ) : (
                    <div>
                        <div className="mb-2">
                            <strong className="text-uppercase">SINGLE TASK/ACTIVITY</strong>
                            <p>{localStack.singleTask || 'Not specified'}</p>
                        </div>
                        <div className="mb-2">
                            <strong className="text-uppercase">INTRINSIC MOTIVATOR</strong>
                            <p>{localStack.intrinsicMotivator === 'curiosityPassionPurpose' ? 'Curiosity/Passion/Purpose' : localStack.intrinsicMotivator === 'autonomy' ? `Autonomy: ${localStack.autonomyExplanation || 'Not specified'}` : localStack.intrinsicMotivator || 'Not specified'}</p>
                            {localStack.intrinsicMotivator === 'curiosityPassionPurpose' && (
                                <p><strong>Why this matters:</strong> {localStack.whyMatters || 'Not specified'}</p>
                            )}
                        </div>
                        <div className="mb-2">
                            <strong className="text-uppercase">COMPLETE CONCENTRATION</strong>
                            <p>{localStack.completeConcentration || 'Not specified'}</p>
                        </div>
                        <div className="mb-2">
                            <strong className="text-uppercase">CLEAR GOAL</strong>
                            <p>{localStack.clearGoal || 'Not specified'}</p>
                        </div>
                        <div className="mb-2">
                            <strong className="text-uppercase">CHALLENGE-SKILL BALANCE</strong>
                            <p><strong>Challenge:</strong> {localStack.challenge || 'Not specified'}</p>
                            <p><strong>Skill:</strong> {localStack.skill || 'Not specified'}</p>
                        </div>
                        <div className="mb-2">
                            <strong className="text-uppercase">IMMEDIATE FEEDBACK</strong>
                            <p>{localStack.immediateFeedback || 'Not specified'}</p>
                        </div>
                        <div className="mb-2">
                            <strong className="text-uppercase">CATALYST(S)</strong>
                            <p>Main — {localStack.catalystMain === 'deepEmbodiment' ? `Deep Embodiment: ${localStack.catalystMainExplanation || 'Not specified'}` : localStack.catalystMain === 'richEnvironment' ? `Rich Environment: ${localStack.catalystMainExplanation || 'Not specified'}` : localStack.catalystMain === 'highConsequence' ? `High Consequence: ${localStack.catalystMainExplanation || 'Not specified'}` : localStack.catalystMain === 'creativity' ? `Creativity: ${localStack.catalystMainExplanation || 'Not specified'}` : localStack.catalystMain === 'other' ? `Other: ${localStack.catalystMainExplanation || 'Not specified'}` : localStack.catalystMain || 'Not specified'}</p>
                            <p>Optional 1 — {localStack.catalystOptional1 === 'deepEmbodiment' ? `Deep Embodiment: ${localStack.catalystOptional1Explanation || 'Not specified'}` : localStack.catalystOptional1 === 'richEnvironment' ? `Rich Environment: ${localStack.catalystOptional1Explanation || 'Not specified'}` : localStack.catalystOptional1 === 'highConsequence' ? `High Consequence: ${localStack.catalystOptional1Explanation || 'Not specified'}` : localStack.catalystOptional1 === 'creativity' ? `Creativity: ${localStack.catalystOptional1Explanation || 'Not specified'}` : localStack.catalystOptional1 === 'other' ? `Other: ${localStack.catalystOptional1Explanation || 'Not specified'}` : localStack.catalystOptional1 || 'Not specified'}</p>
                            <p>Optional 2 — {localStack.catalystOptional2 === 'deepEmbodiment' ? `Deep Embodiment: ${localStack.catalystOptional2Explanation || 'Not specified'}` : localStack.catalystOptional2 === 'richEnvironment' ? `Rich Environment: ${localStack.catalystOptional2Explanation || 'Not specified'}` : localStack.catalystOptional2 === 'highConsequence' ? `High Consequence: ${localStack.catalystOptional2Explanation || 'Not specified'}` : localStack.catalystOptional2 === 'creativity' ? `Creativity: ${localStack.catalystOptional2Explanation || 'Not specified'}` : localStack.catalystOptional2 === 'other' ? `Other: ${localStack.catalystOptional2Explanation || 'Not specified'}` : localStack.catalystOptional2 || 'Not specified'}</p>
                        </div>
                        <div className="mb-2">
                            <strong className="text-uppercase">FINAL STACK STATEMENT</strong>
                            <p>When will you test this Flow Trigger Stack?: {localStack.whenTest || 'Not specified'}</p>
                            <p>What worked: {localStack.whatWorked || 'Not specified'}</p>
                            <p>What didn't: {localStack.whatDidnt || 'Not specified'}</p>
                            <p>What needs adjustment?: {localStack.needsAdjustment || 'Not specified'}</p>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default FlowTriggerStack;
